import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css']
})
export class RedirectComponent implements OnInit {

  newUrl = '';
  showContinueButton = true;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
    try {
      var params = this.getJsonFromUrl();
      if (params !== undefined) {
        this.newUrl = decodeURIComponent(params['url']);
      }
    }
    catch (err) {
      var base_url = window.location.origin;
      if (window.location.pathname !== undefined && window.location.pathname !== null) {
        var pathArray = window.location.pathname.split('/');
        if (pathArray.length > 1) {
          var errorUrl = base_url + "/" + pathArray[1] + "/Error/Index?code=999";
          if (window.top && window.top.location) window.top.location.href = errorUrl;
          else window.location.href = errorUrl;
          return;
        }
      }
      // if we could not get proper error url
      if (window.top && window.top.location) window.top.location.href = 'https://www.scanwritr.com/app/Error/Index?code=999';
      else window.location.href = 'https://www.scanwritr.com/app/Error/Index?code=999';
    }
  }

  start() {
    // change top iframe url
    this.showContinueButton = false;
    if (window.top && window.top.location)
      window.top.location.href = this.newUrl;
    else
      window.location.href = this.newUrl;
  }

  getJsonFromUrl() {
    var result = {};
    if (location.search !== undefined && location.search.length > 1) {
      var query = location.search.substr(1);
      query.split("&").forEach(part => {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
      });
    }
    return result;
  }

}
